"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorRecovery = exports.useErrorBoundaryContext = exports.ErrorBoundaryContext = void 0;
var _react = require("react");
var ErrorBoundaryContext = /*#__PURE__*/(0, _react.createContext)();
exports.ErrorBoundaryContext = ErrorBoundaryContext;
var useErrorBoundaryContext = function useErrorBoundaryContext() {
  var context = (0, _react.useContext)(ErrorBoundaryContext);
  if (typeof context === "undefined") {
    throw new Error("useErrorBoundary must be used within a ErrorBoundary");
  }
  return context;
};
exports.useErrorBoundaryContext = useErrorBoundaryContext;
var useErrorRecovery = function useErrorRecovery() {
  return useErrorBoundaryContext().recoveryState();
};
exports.useErrorRecovery = useErrorRecovery;